import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { APIErrors, APISuccess } from '@util';
import { config } from 'environment';
import { Observable } from 'rxjs';
import { PUBLIC_HEADERS } from './authentication.service';

export interface StripeProduct {
	name: string;
	maxUsers: number;
	sessionID: string;
	clientSecret: string;
}

export interface StripeStudent {
	firstName: string;
	lastName: string;
	email: string;
}

export interface StripeSessionStatus {
	status: 'complete' | 'expired' | 'open' | null;
	productID: string | null;
}

@Injectable({
	providedIn: 'root',
})
export class StripeService {
	stripePromise: Promise<Stripe | null> = loadStripe(
		config.stripePublishableKey,
	);

	constructor(private _http: HttpClient) {}

	getProduct(productID: string): Observable<StripeProduct | APIErrors> {
		return this._http.get<StripeProduct | APIErrors>(
			`${config.apiBase}public/purchase/product?productID=${productID}`,
			{ headers: PUBLIC_HEADERS },
		);
	}

	updateSession(
		sessionID: string,
		students: Array<StripeStudent>,
	): Observable<APISuccess | APIErrors> {
		return this._http.post<APISuccess | APIErrors>(
			`${config.apiBase}public/purchase/update`,
			{ sessionID, students },
			{ headers: PUBLIC_HEADERS },
		);
	}

	getStatus(sessionID: string): Observable<StripeSessionStatus | APIErrors> {
		return this._http.get<StripeSessionStatus | APIErrors>(
			`${config.apiBase}public/purchase/status?sessionID=${sessionID}`,
			{ headers: PUBLIC_HEADERS },
		);
	}
}
